import React, { useEffect, useRef, useState, useCallback } from "react";
import TextField from "@mui/material/TextField";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
// import TableComponent from "./Table";
import ProductsInfo from "./ProductsInfo";
import whatsapp from "../../utils/whatsapp.png";
import { useLocation } from "react-router-dom";
import { format } from "date-fns";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import ItemSearchPopup from "./ItemSearchPopup";
import "../../css/allEntriesForm.css";
import CustomerSearchF2Popup from "../../modals/CustomerSearchF2Popup";
import Autocomplete from "@mui/material/Autocomplete";
import CreditCustomerList from "../common/CreditCustomerList";
import Modal from "../common/CommonModal";
import ProductsModal from "../salesInvoice/ProductsModal";
import useApi from "../../hooks/useApi";
import JobCodeList from "../common/JobCodeList";
import canUserSeeThis from "../common/CheckCanUserSeeThis";

const AllEntriesForm = ({ onFormSubmit, toEditLead, onEditCancelLead }) => {
  const COMPANY_CODE = localStorage.getItem("companyCode");
  const organizationInputRef = useRef(null);
  const [showDupCheckName, setShowDupCheckName] = useState(false);
  const debounceTimer = useRef(null);
  const [modalPageNumber, setModalPageNumber] = useState(1);
  const [modalPageSize] = useState(500);
  const [modalTotalRows, setModalTotalRows] = useState(0);
  const [modalSearchQuery, setModalSearchQuery] = useState("-");

  const [page] = useState(1);
  const PAGE_SIZE = 50;

  const { request, loading } = useApi();

  const [searchBy, setSearchBy] = useState("UNIVERSAL");

  const [modalSuggestions, setModalSuggestions] = useState([]);

  const [currencyList, setCurrencyList] = useState(null);

  const [currency, setCurrency] = useState(currencyList?.[0]?.curno || "-");
  const currencyRef = useRef(null);
  let company_code_from_local_storage = localStorage.getItem("companyCode")
    ? localStorage.getItem("companyCode")
    : "-"; // only if user manually delete the key else condition would work , not even possible because if deleted then will be blocked at machine registration checking
  let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";
  const masterCompanyCode = localStorage.getItem("masterCompanyCode");
  const isEmailRequired =
    masterCompanyCode?.toUpperCase() !== "FORUMGROUP" &&
    company_code_from_local_storage?.toUpperCase() !==
      masterCompanyCode?.toUpperCase();

  const [f2PopupProjectViewToggle, setF2PopupProjectViewToggle] =
    useState(false);
  const [f2CustomerSearch, setF2CustomerSearch] = useState(false);
  const [f2PopupViewToggle, setF2PopupViewToggle] = useState(false);
  const [currentF2ItemForSearchPopup, setCurrentF2ItemForSearchPopup] =
    useState(0);

  const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
  const userAccessGroup = currentUserObject[0].accessgrp;

  useEffect(() => {
    const savedSalesperson = currentUserObject[0].sales_man;

    if (savedSalesperson) {
      setFormData((prev) => ({
        ...prev,
        salesperson: savedSalesperson,
      }));
    }
  }, []);

  const [accessgroupFromLocal, setAccessgroupFromLocal] =
    useState(userAccessGroup);
  const isAdmin = accessgroupFromLocal === "ADMIN";

  useEffect(() => {
    console.log("currentF2ItemForSearchPopup", currentF2ItemForSearchPopup);
  }, [currentF2ItemForSearchPopup]);
  // const location = useLocation();

  // const toEditLead = location.state?.toEditLead;

  const currentUserName = localStorage.getItem("currentUserName");

  const [userName, setUserName] = useState(currentUserName);

  console.log("toEditLead updated in AllEntriesForm:", toEditLead);

  const currentUserfromLocalStorage = JSON.parse(
    localStorage.getItem("currentUser")
  );

  const currentDepartmentFromLocalStorage = localStorage.getItem(
    "currentSelectedDepartment"
  );

  let currentUserEMPID = "-";

  if (currentUserfromLocalStorage) {
    console.log(
      "currentUserfromLocalStorage[0] ",
      currentUserfromLocalStorage[0]
    );
    currentUserEMPID = currentUserfromLocalStorage[0]?.EMPID;
  } else {
    console.log(
      "currentUserfromLocalStorage[0] else",
      currentUserfromLocalStorage[0]
    );
  }

  const [coordinatorList, setCoordinatorList] = useState(null);
  const [salespersonList, setSalesPersonList] = useState(null);
  const [rowToFocusId, setRowToFocusId] = useState(null);
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    fetch("https://cdn.jsdelivr.net/npm/world-countries/countries.json")
      .then((res) => res.json())
      .then((data) => {
        const formatted = data
          .map((c) => ({
            label: c.name.common,
            value: c.name.common,
          }))
          .sort((a, b) => a.label.localeCompare(b.label));

        setCountries(formatted);
      })
      .catch(console.error);
  }, []);
  const rowInputRefs = useRef({});
  const qtyInputRefsFromParent = useRef({});  

  useEffect(() => {
    console.log("rowToFocusId ", rowToFocusId, rowInputRefs.current);
    // Check if there is a row ID flagged for focus
    if (rowToFocusId && rowInputRefs.current[rowToFocusId]) {
      const inputRef = rowInputRefs.current[rowToFocusId];

      // Wait for the ref to contain the actual DOM element (after component render)
      if (inputRef.current) {
        // The itemcode TextField from MUI needs .focus() called on its underlying input element
        inputRef.current.focus();

        // Clear the focus ID state to prevent re-focusing on subsequent re-renders
        setRowToFocusId(null);
      }
    }
  }, [rowToFocusId]);

  let API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : null;
  const defaultCountryDecidingText = API_PATHS ? API_PATHS[0]?.ADDRESS : null;

  let countryName = "United Arab Emirates";

  const getCountry = (text) => {
    switch (text?.toLowerCase()) {
      case "dubai":
        countryName = "United Arab Emirates";
        return countryName;
      case "saudi":
        countryName = "Saudi Arabia";
        return countryName;
      case "china":
        countryName = "China";
        return countryName;
      default:
        countryName = "United Arab Emirates";
        return countryName;
    }
  };

  useEffect(() => {
    if (defaultCountryDecidingText) {
      setFormData((prev) => ({
        ...prev,
        country: getCountry(defaultCountryDecidingText),
      }));
    }
  }, [defaultCountryDecidingText]);

  console.log("countryName", countryName);
  const initialFormData = {
    id: Date.now(), // [lead_id]
    // name: "", // ,[lead_primarycontact]
    lead: "", // ,[lead_primarycontact]
    phone: "", // [lead_phone]
    alternatePhone: "", // ,[lead_alt_phone]
    isPhoneWhatsApp: false, // [lead_isphonewhatsapp]
    isAlternatePhoneWhatsApp: false, // [lead_alt_isphonewhatsapp]
    status: "newLead", // [lead_status]
    organization: "", // ,[lead_organization]
    title: "", // ,[lead_primarycontacttitle]
    email: "", // [lead_email]
    notes: "", // [lead_notes]
    leadSource: "",
    coordinator: "", // [lead_coordinator],
    salesperson: "", // [lead_coordinator]
    assignTo: "", //[lead_assignedto]
    docs: "",
    campaignId: "", // [lead_CampaignId]
    departmentNo: "", // ,[deptno]
    // leadDateAndTimeEntry: "",==========
    probability: "", // [lead_probability]
    currency: "",
    bookedAmount: "", // [lead_bookedamount]
    territory: "", // [lead_territory]
    country: getCountry(defaultCountryDecidingText), // [lead_country]
    streetAddress: "", // [lead_streetaddress]
    city: "", // [lead_city]
    apartment: "", // [lead_appartment]
    location: "", // ,[lead_location]
    area: "", // ,[lead_area]
    priority: "", // [lead_priority]
    leadEntryTime: "", // ,[lead_entryTime]
    timeline: "",
    isItemAdded: "",
    itemCode: "",
    itemDescription: "",
    itemUnit: "",
    itemCurrentStock: "",
    itemQuantity: "",
    itemPrice: "",
    itemAmount: "",
    // [lead_stage]

    // i dont have
    // ,[lead_currencycode]
    // ,[lead_currencyrate]
    // ,[lead_salesperson]
    // ,[lead_teamid]
    // ,[lead_account]

    // "CmpCode": null,
    // "mode": null,
    // "alternateEmail": null,
    //   "SalesPerson": null,
    //   "TeamID": null,
    //   "Coordinator": null,
    //   "Comments": null,
    //   "CampaignId": null,
    //   "CreatedBy": null,
    //   "deptno": null,
    //   "Prod_code": null,
    //   "Prod_Description": null,
    //   "Prod_Unit": null,
    //   "Prod_Qty": null,
    //   "Prod_Price": null,
    //   "Prod_Amount": null,
    //   "Prod_Comments": null
  };

  const [addProduct, setAddProduct] = useState(false);
  const [openDialogBox, setOpenDialogBox] = useState(false);
  const [messageForUser, setMessageForUser] = useState(null);
  const [productData, setProductData] = useState([]);
  const [productEntries, setProductEntries] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentProductEntryRowId, setCurrentProductEntryRowId] =
    useState(null);
  const [currentProductTyping, setCurrentProductTyping] = useState(null);

  const productEntriesRef = useRef(productEntries);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openSubmitSnackbar, setOpenSubmitSnackbar] = useState(false);
  const [errorRow, setErrorRow] = useState(null);
  const [isSubmittingForm, setIsSubmittingForm] = useState(false);
  const [fileName, setFileName] = useState("No file chosen");
  const [organizationList, setOrganizationList] = useState([]);
  const [duplicateItemCodeSnackbar, setDuplicateItemCodeSnackbar] =
    useState(false);
  const [userDepartment, setUserDepartment] = useState(null);

  const defaultRow = {
    id: Date.now(),
    itemCode: "",
    itemDescription: "",
    itemUnit: "",
    itemCurrentStock: "",
    itemQuantity: "",
    itemPrice: "",
    itemAmount: "",
    isSelectedItemCodeCorrect: false,
  };

  // useEffect(() => {
  //   setUserDepartment(currentDepartmentFromLocalStorage);
  //   const savedProducts = localStorage.getItem("currentEdittingProductsList");
  //   if (savedProducts) {
  //     const parsedProducts = JSON.parse(savedProducts);
  //     if (Array.isArray(parsedProducts) && parsedProducts.length > 0) {
  //       setProductEntries(parsedProducts); // Restore previous state
  //     }
  //   }

  //   document.addEventListener("keydown", e => {
  //     if (e.key === "F2") {
  //       // Suppress default behaviour
  //       // e.g. F1 in Microsoft Edge on Windows usually opens Windows help
  //       e.preventDefault()
  //     }

  //   })

  //   document.addEventListener("keyup", e => {

  //     console.log("name of input f2 clicked", e.target.name)

  //     if (e.altKey && e.key === 'a') {
  //       e.preventDefault(); // Stop default browser action
  //       setAddProduct(true); // Or setAddProduct(prev => !prev) if it toggles a boolean
  //     }

  //     if (e.key === "F2") {
  //       // Handle the keyup event
  //       console.log("f2 pressed")
  //       if (e.target.name === "organization") {
  //         setF2CustomerSearch(true)

  //       }
  //       if (e.target.name === "itemcode") {
  //         setF2PopupViewToggle(true)
  //       }

  //     }
  //   })

  // }, []);

  useEffect(() => {
    setUserDepartment(currentDepartmentFromLocalStorage);

    const savedProducts = localStorage.getItem("currentEdittingProductsList");
    if (savedProducts) {
      const parsedProducts = JSON.parse(savedProducts);
      if (Array.isArray(parsedProducts) && parsedProducts.length > 0) {
        setProductEntries(parsedProducts);
      }
    }

    const handleKeyDown = (e) => {
      if (e.key === "F2") {
        e.preventDefault();
      }

      // Handle Alt+A on keydown to prevent default immediately
      if (e.altKey && (e.code === "KeyA" || e.key === "a")) {
        e.preventDefault();
        console.log("Key down >>>>>>>> inside");
      }
    };

    const handleKeyUp = (e) => {
      console.log("Key pressed:", e.key, "altKey:", e.altKey, "code:", e.code);

      // Use e.code instead of e.key for Mac compatibility
      if (e.altKey && e.code === "KeyA") {
        e.preventDefault();
        console.log("Alt+A pressed - opening add product");

        setAddProduct(true);

        // not working
        // const currentEntries = productEntriesRef.current;
        // const firstRow = currentEntries[0]?.id;
        // console.log("firstRow from ref: ", firstRow);
        // if (firstRow) {
        //   setRowToFocusId(firstRow);
        // }

        // not working
        // handleAddRow(null)

        return;
      }

      // F2 handler
      if (e.key === "F2") {
        console.log("F2 pressed");
        if (e.target.name === "organization") {
          setF2CustomerSearch(true);
        }
        if (e.target.name === "itemcode") {
          setF2PopupViewToggle(true);
        }

        if (e.target.name === "campaignId") {
          setF2PopupProjectViewToggle(true);
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("keyup", handleKeyUp);

    // Cleanup function - IMPORTANT!
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("keyup", handleKeyUp);
    };
  }, []); // Empty dependency array

  console.log("userDepartment", userDepartment);

  const handleAddRow = (e) => {
    console.log("handleAddRow called", e, productEntries.length);

    if (e) {
      e.preventDefault();
    }

    if (productEntries.length > 0) {
      const lastRow = productEntries[productEntries.length - 1];
      const lastItemCode = lastRow.Prod_code || lastRow.itemCode;

      console.log("lastRow", lastRow);
      // ⭐️ If the last row's item code is empty, stop here
      if (!lastItemCode || lastItemCode.trim() === "") {
        // Optional: Show a message or just return
        console.log("Fill current item code before adding a new row");
        setRowToFocusId(lastRow.id);
        return;
      }
    }

    const newRowId = Date.now();

    const newRow = {
      id: newRowId,
      itemCode: "",
      itemDescription: "",
      itemImage: "",
      itemUnit: "",
      itemCurrentStock: "",
      itemQuantity: "",
      itemPrice: "",
      itemAmount: "",
      isSelectedItemCodeCorrect: false,
    };

    setProductEntries((prevEntries) => [...prevEntries, newRow]);

    rowInputRefs.current[newRowId] = React.createRef();

    setRowToFocusId(newRowId);
  };

  const handleDeleteSelected = (e) => {
    e.preventDefault();
    console.log("productToDelete::", e.target.value);

    const remainingRows = productEntries.filter(
      (entry) => !selectedRows.includes(entry.id)
    );

    // Ensure at least one row exists
    if (remainingRows.length === 0) {
      remainingRows.push({ ...defaultRow, id: Date.now() });
    }

    setProductEntries(remainingRows);
    setSelectedRows([]);
  };

  const handleInputChange = (id, field, value) => {
    console.log("id f v", id, field, value);

    setCurrentProductEntryRowId(id);

    // Set the current value being typed
    setCurrentProductTyping(value);
    if (field === "itemCode") {
      console.log("itemcode is set");
      fetchItemDetails(value, id); // Call your fetch function for item details
    }

    // Update the productEntries state with the new value
    let newArray = productEntries.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          [field]: value,
          ...(field === "itemCode" && { isSelectedItemCodeCorrect: false }), // Set isSelectedItemCodeCorrect to false when itemCode changes
        };
      }
      return item;
    });

    // Set the updated productEntries array to state
    setProductEntries(newArray);
  };

  // call manoj sir's new api with pagination when entry related we can hardcode column name when showing data in table call dynamic ie whatever coming from api show dynamically without harcoding column name
  // const fetchItemDetails = async (itemCode, rowId) => {
  //   console.log(`Fetching details for Item Code: ${itemCode}`); // Log item code before fetching
  //   if (!itemCode) return;

  //   setTimeout(async () => {
  //     try {
  //       const response = await fetch(
  //         `${apiPaths_from_local_storage[0].API_CONFIG}/api/Search_Items/${company_code_from_local_storage}/Sitem/${itemCode}`
  //       );

  //       console.log("API response status:", response.status); // Log API response status

  //       const data = await response.json();
  //       console.log("API response data:", data); // Log response data
  //       setProductData(data);
  //     } catch (error) {
  //       console.error("Error fetching item details:", error);
  //     }
  //   }, 500); // Delay API call to avoid excessive requests
  // };

  const fetchItemDetails = async (itemCode, rowId) => {
    // 1. Clear any existing timer from the previous keystroke
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    if (!itemCode || itemCode.trim() === "") {
      setProductData([]);
      return;
    }

    console.log(`Fetching details for Item Code: ${itemCode}`); // Log item code before fetching
    if (!itemCode) return;

    debounceTimer.current = setTimeout(async () => {
      try {
        const formattedQuery = itemCode.replace(/\//g, "%2F");

        const location = currentUserObject.filter(
          (item) => item.DEPTNO === currentDepartmentFromLocalStorage
        )[0]
          ? currentUserObject.filter(
              (item) => item.DEPTNO === currentDepartmentFromLocalStorage
            )[0].VAN
          : "-";

        const url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMStocksubList/${company_code_from_local_storage}/${searchBy}/${formattedQuery}/${location}/-/${page}/${PAGE_SIZE}`;
        const response = await fetch(url);

        const data = await response.json();
        console.log("API response data: pagination", data); // Log response data
        setProductData(data);
      } catch (error) {
        console.error("Error fetching item details:", error);
      }
    }, 500); // Delay API call to avoid excessive requests
  };

  const selectProduct = (setProductCode) => {
    console.log("index of select product", setProductCode);
    setIsSubmittingForm(true);

    // removed duplicate checking while selecting from popup also not checking
    // const isDuplicate = productEntries.some(
    //   (product) => product.itemCode === setProductCode
    // );
    // if (isDuplicate) {
    //   // alert('this item already exists')
    //   setDuplicateItemCodeSnackbar(true);
    //   setIsSubmittingForm(false);
    //   return;
    // }

    const selectedProduct = productData.find(
      (product) => product.Code === setProductCode
    );

    if (selectedProduct) {
      setProductEntries((prevEntries) =>
        prevEntries.map((entry) =>
          entry.id === currentProductEntryRowId
            ? {
                ...entry,
                itemCode: selectedProduct.Code,
                itemDescription: selectedProduct.Description,
                itemImage: selectedProduct.Imagepath,
                // itemUnit: selectedProduct.unit,
                itemUnit: selectedProduct.Unit,
                itemCurrentStock: selectedProduct.Ttl_Stk, // Adjust according to your product data
                itemPrice: selectedProduct.SelPrice, // Adjust according to your product data
                itemAmount: selectedProduct.SelPrice * entry.itemQuantity, // Example calculation
                isSelectedItemCodeCorrect: true, // Example calculation
              }
            : entry
        )
      );
    }
    setIsDropdownOpen(false);
    setProductData(null);
  };

  const selectCustomerOrganization = (customer) => {
    console.log("customer after select customer", customer);

    // here call state spread replace oraganisation with selected value use this object tot saveThatLeadFormState
    //customer.Custname

    let salesmanNameToPutInForm = "";

    let salesPersonNameObject = salespersonList?.find(
      (item) => item.EMP_ID?.trim() === customer.sale_man?.trim()
    );
    if (salesPersonNameObject) {
      salesmanNameToPutInForm = customer.sale_man;
    } else {
      if (
        accessgroupFromLocal != "ADMIN" &&
        accessgroupFromLocal != "COORDINATOR"
      ) {
        let empIdFromLocal = localStorage.getItem("currentUserEmployeeID");
        if (empIdFromLocal) {
          salesmanNameToPutInForm = empIdFromLocal;
        }
      }
    }

    // console.log("salesmanNameToPutInForm array was ", salesPersonNameObject, salespersonList)

    setFormData({
      ...formData,
      account: customer.account?.trim(),
      organization: customer.Custname?.trim(),
      // lead: customer.Custname,
      phone: customer.phone?.trim(),
      salesperson: salesmanNameToPutInForm,
      email: customer.email?.trim(),
      streetAddress: customer.address1?.trim(),
      autoid: customer.autoid,
    });
  };

  useEffect(() => {
    if (productEntries.length === 0) {
      // clearProductsList()
      localStorage.removeItem("currentEdittingProductsList");
    } else {
      productEntriesRef.current = productEntries;
    }
  }, [productEntries]);

  useEffect(() => {
    console.log("productEntries1", productEntries);

    if (productEntries.length > 0) {
      setAddProduct(true);
    }

    localStorage.setItem(
      "currentEdittingProductsList",
      JSON.stringify(productEntries)
    );
    const itemCodeInProducts = productEntries.map(
      (itemcodeProd) => itemcodeProd.itemCode
    );
    console.log("itemCodeInProducts:", itemCodeInProducts);

    // Check if any item has isSelectedItemCodeCorrect as false
    const hasIncorrectItemCode = productEntries.some(
      (item) => !item.isSelectedItemCodeCorrect
    );

    if (hasIncorrectItemCode) {
      setIsSubmittingForm(false);
    }
  }, [productEntries]);

  const existingFormData = () => {
    const savedData = localStorage.getItem("currentEditingLeadForm");
    return savedData ? JSON.parse(savedData) : initialFormData;
  };

  const [formData, setFormData] = useState(toEditLead || existingFormData());

  //const [formData, setFormData] = useState(toEditLead || initialFormData);

  useEffect(() => {
    localStorage.setItem("currentEditingLeadForm", JSON.stringify(formData));
    console.log("formData updated:", formData);
  }, [formData]);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    console.log("handleChange:", name, value);

    // Focus handling for probability → currency
    if (name === "probability" && currencyRef.current) {
      setTimeout(() => {
        currencyRef.current.focus();
      }, 0);
    }

    // Fetch org list when lead changes
    if (name === "lead") {
      fetchOrganizationList(value);
    }

    // Special handling for organization
    if (name === "organization") {
      fetchOrganizationList(value);

      setFormData((prev) => ({
        ...prev,
        account: "00000000",
        organization: value,
        phone: "",
        salesperson: "",
        email: "",
        streetAddress: "",
        autoid: "0",
      }));

      return;
    }

    // File input handling
    if (type === "file") {
      const file = files?.[0];
      setFileName(file ? file.name : "No file chosen");
      return;
    }

    // Main form update (single source of truth)
    setFormData((prev) => {
      if (name === "country") {
        return {
          ...prev,
          country: value,
          territory: "",
        };
      }

      return {
        ...prev,
        [name]: name === "territory" ? value.toLowerCase() : value,
      };
    });

    // Territory label handling
    if (name === "country") {
      switch (value) {
        case "United Arab Emirates":
          setTerritoryLabel("Emirate");
          break;
        case "Saudi Arabia":
          setTerritoryLabel("Territory");
          break;
        case "china":
          setTerritoryLabel("Territory");
          break;
        case "unitedStates":
          setTerritoryLabel("State");
          break;
        case "unitedKingdom":
          setTerritoryLabel("County");
          break;
        case "india":
          setTerritoryLabel("State");
          break;
        case "canada":
          setTerritoryLabel("Province");
          break;
        case "australia":
          setTerritoryLabel("Region");
          break;
        default:
          setTerritoryLabel("Territory");
      }
    }
  };

  const fetchOrganizationList = async (value) => {
    console.log(
      "fetching organization list >>> ---",
      apiPaths_from_local_storage[0].API_CONFIG
    );
    // setTimeout(async() => {
    if (!value || value.length < 1) {
      return;
    } else {
      try {
        // const response = await axios.get(
        //   `${apiPaths_from_local_storage[0].API_CONFIG}/api/Search_Customer/${company_code_from_local_storage}/Cust/${value}/${userDepartment}`
        // );

        const response = await axios.get(
          `${apiPaths_from_local_storage[0].API_CONFIG}/api/Search_Customer/${company_code_from_local_storage}/Custcrm/${value}/${userDepartment}`
        );
        // console.log("organizationList is fetched success", response.data);
        setOrganizationList(response.data);
      } catch (error) {
        console.log("Error fetching organization details:", error);
      }
    }
  };

  const fetchOrganizationListForF2Search = async (value) => {
    console.log(
      "fetching organization list for f2 customer >>> ",
      apiPaths_from_local_storage[0].API_CONFIG
    );
    // setTimeout(async() => {
    if (!value || value.length < 1) {
      return;
    } else {
      try {
        const response = await axios.get(
          `${apiPaths_from_local_storage[0].API_CONFIG}/api/Search_Customer/${company_code_from_local_storage}/Cust/${value}/${userDepartment}`
        );
        // console.log("organizationList is fetched success", response.data);
        return response.data;
      } catch (error) {
        console.log("Error fetching organization details:", error);
      }
    }
  };

  const toTitleCase = (str) => {
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const cancelForm = (e) => {
    console.log("cancel Lead ", e.target.value);
    setFormData(initialFormData);
    clearProductsList();
    clearLeadList();
    setProductEntries([]);
  };

  const handleUpdate = (e) => {
    e.preventDefault();

    const currentTimestamp = new Date().toISOString(); // Capture edit time

    const updatedLead = {
      // ...selectedLead, // Retain existing lead details
      ...toEditLead, // Retain existing lead details
      ...formData, // Override with new form data
      name: formData.lead ? toTitleCase(formData.lead) : toEditLead?.lead || "",
      organization: formData.organization
        ? toTitleCase(formData.organization)
        : toEditLead?.organization || "",
      title: formData.title
        ? toTitleCase(formData.title)
        : toEditLead?.title || "",
      city: formData.city ? toTitleCase(formData.city) : toEditLead?.city || "",
      lastUpdated: currentTimestamp, // Store last updated time
      timeline: [
        ...(toEditLead?.timeline || []), // Keep existing timeline
        {
          date: currentTimestamp,
          activity: "Lead details updated",
        },
      ],
    };

    console.log("Updated Lead Data:", updatedLead);

    onFormSubmit(updatedLead); // Submit updated data
    // alert("Lead Updated Successfully!");
    setFormData(initialFormData);
  };

  const handleSubmit = async (e) => {
    if (Number(formData.autoid) === 0 && formData.account === "00000000") {
      let name_number_combined =
        formData.organization?.trim() + formData.phone?.trim();

        const cleaned = name_number_combined.replace(/\+/g, '');          // remove the +
const encoded = encodeURIComponent(cleaned); 

      setShowDupCheckName(true);

      let url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/DupCheck/${company_code_from_local_storage}/AUTOIDPICK/${encoded}`;
      console.log("url duplicate", url);
      const response = await axios.get(url);

      setShowDupCheckName(false);

      if (response?.data) {
        if (response?.data?.length > 0) {
          alert("Cannot Save, name or phone number is duplicate ");
          return;
        }
      }
    }

    

    console.log("e", e.target.value);
    e.preventDefault();
    console.log("isSubmittingForm:", isSubmittingForm);

    console.log("productEntries:", productEntries);
    const errorRows = productEntries
      .map((prod, index) =>
        !prod.isSelectedItemCodeCorrect && prod.itemCode.length > 0
          ? index + 1
          : -1
      )
      .filter((index) => index !== -1); // Filter out invalid indices (-1)

    if (errorRows.length > 0) {
      console.log("Incorrect Item Codes found at indices:", errorRows);
      setErrorRow(errorRows);
      setOpenSnackbar(true);
      return;
    } else {
      // setOpenSubmitSnackbar(true); // Show success snackbar
      // setOpenSubmitSnackbar(true); // Show success snackbar
    }

    // if(isSubmitingForm){

    const currentTimestamp = new Date().toISOString(); // Get the current timestamp

    // Apply title case to relevant fields
    const formDataWithTitleCase = {
      ...formData,
      name: formData.lead ? toTitleCase(formData.lead) : "", // Convert name to title case
      organization: formData.organization
        ? toTitleCase(formData.organization)
        : "", // Convert name to title case
      title: formData.title ? toTitleCase(formData.title) : "", // Convert name to title case
      city: formData.city ? toTitleCase(formData.city) : "", // Convert city to title case
      leadEntryTime: currentTimestamp,
      timeline: [
        {
          date: currentTimestamp,
          activity: "Lead created",
        },
      ],
    };

    console.log(
      "Form Data with Lead Entry Time and Title Case:",
      formDataWithTitleCase
    );

    //onFormSubmit(formDataWithTitleCase);
    // setContacts(formDataWithTitleCase);

    callAPIToSaveData(formDataWithTitleCase);

    setTimeout(() => {
      if (organizationInputRef.current) {
        organizationInputRef.current.focus();
      }
    }, 0);
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };
  const handleCloseSubmitSnackbar = () => {
    setOpenSubmitSnackbar(false);
    setDuplicateItemCodeSnackbar(false);
  };

  const clearLeadList = () => {
    localStorage.removeItem("currentEdittingLeadList");
    setFormData(initialFormData);
  };

  const clearProductsList = () => {
    localStorage.removeItem("currentEdittingProductsList");
    setProductData([]);
  };

  useEffect(() => {
    const savedProducts = localStorage.getItem("currentEdittingProductsList");
    if (savedProducts) {
      const parsedProducts = JSON.parse(savedProducts);
      if (Array.isArray(parsedProducts) && parsedProducts.length > 0) {
        setProductData(parsedProducts); // Restore previous state
      }
    }

    
//set salesperson name if accegrp is COORDINATOR
    if (
      accessgroupFromLocal?.trim()?.toUpperCase() === "COORDINATOR"
    ) {
      let empIdFromLocal = localStorage.getItem("currentUserEmployeeID");
      if (empIdFromLocal) {
        setFormData({
          ...formData,
          coordinator: empIdFromLocal,
        });
      }
    }
   //set salesperson name if accegrp is other than these 2

    if (
      accessgroupFromLocal != "ADMIN" &&
      accessgroupFromLocal != "COORDINATOR"
    ) {
      let empIdFromLocal = localStorage.getItem("currentUserEmployeeID");
      if (empIdFromLocal) {
        let salesmanNameToPutInForm = empIdFromLocal;
        setFormData({
          ...formData,
          coordinator: "GENERAL",
          salesperson: salesmanNameToPutInForm,
        });
      }
    }
  }, []);

  const callAPIToSaveData = (dataForAPI) => {
    console.log("dataForAPI:", dataForAPI);
    console.log("productEntries:", productEntries);

    let arrayWeHaveToGiveToAPI = [];

    if (productEntries.length > 0) {
      arrayWeHaveToGiveToAPI = productEntries.map((product, index) => {
        // {console.log("product.itemAmount:::",product.itemAmount)}
        // {console.log("productItemCode:::",product.itemCode)}
        // {console.log("product.itemCurrentStock:::",product.itemCurrentStock)}
        // {console.log("product.itemDescription:::",product.itemDescription)}
        // {console.log("product.itemImage:::",product.itemImage)}
        // {console.log("product.itemPrice:::",product.itemPrice)}
        // {console.log("product.itemQuantity:::",product.itemQuantity)}
        // {console.log("product.itemUnit:::",product.itemUnit)}
        return {
          CmpCode: company_code_from_local_storage,
          mode: formData.isEditinglead ? "EDIT" : "ENTRY",
          lead_id: dataForAPI.id + "",
          lead_entryTime: format(new Date(), "yyyy-MM-dd"),
          lead_creatorid: currentUserEMPID?.trim(),
          // lead_coordinator:
          //   accessgroupFromLocal === "COORDINATOR" ||
          //   accessgroupFromLocal === "ADMIN"
          //     ? currentUserEMPID?.trim()
          //     : "-", // if selected coordinator is general pass - pass blank if general passed confirmed manoj sir 
          lead_coordinator:
            dataForAPI.coordinator == "GENERAL" ? "" : dataForAPI.coordinator, // if selected coordinator is general pass blank string
          lead_salesperson: dataForAPI.salesperson?.trim(), //
          lead_teamid: "0",
          lead_CampaignId: dataForAPI.campaignId,
          lead_account: dataForAPI.account,
          lead_organization: dataForAPI.organization,
          lead_notes: dataForAPI.notes,
          lead_country: dataForAPI.country,
          lead_city: dataForAPI.city,
          lead_territory: dataForAPI.territory,
          lead_area: dataForAPI.area,
          lead_streetaddress: dataForAPI.streetAddress,
          lead_location: dataForAPI.location,
          lead_appartment: dataForAPI.apartment,
          lead_primarycontact: dataForAPI.name,
          lead_primarycontacttitle: dataForAPI.title,
          lead_phone: dataForAPI.phone,
          lead_isphonewhatsapp: dataForAPI.isPhoneWhatsApp,
          lead_alt_phone: dataForAPI.alternatePhone, //
          lead_alt_isphonewhatsapp: dataForAPI.isAlternatePhoneWhatsApp, //
          lead_email: dataForAPI.email, //
          lead_stage: "", //
          lead_probability: dataForAPI.probability, //
          // lead_probability: Number(dataForAPI.probability), //
          lead_priority: dataForAPI.priority,
          // lead_priority: getPriorityName(dataForAPI.priority),
          lead_source: dataForAPI.leadSource, //
          lead_status: dataForAPI.status, //
          lead_assignedto: dataForAPI.assignTo, //
          lead_bookedamount: Number(dataForAPI.bookedAmount), //
          lead_currencycode: currencyList[0].curno, // dataForAPI.currency, //
          lead_currencyrate: "1", //
          deptno: currentDepartmentFromLocalStorage, //
          prod_code: product.itemCode, //
          prod_Description: product.itemDescription, //
          prod_Unit: product.itemUnit || "0", //
          // prod_Qty: Number(product.itemQuantity) || 0, //
          prod_Qty: product.itemQuantity || "0", //
          // prod_Price: Number(product.itemPrice) || 0, //
          prod_Price: product.itemPrice || 0, //
          // prod_Amount:
          //   (Number(product.itemQuantity) || 0) *
          //   (Number(product.itemPrice) || 0), //
          prod_Amount: 0, //
          prod_Comments: "", //
          prod_imagepath: "", //
          autoid: dataForAPI.autoid ? dataForAPI.autoid : "0",
        };
      });
    } else {
      arrayWeHaveToGiveToAPI = [
        {
          CmpCode: company_code_from_local_storage,
          mode: formData.isEditinglead ? "EDIT" : "ENTRY",
          lead_id: dataForAPI.id + "",
          lead_entryTime: format(new Date(), "yyyy-MM-dd"),
          lead_creatorid: currentUserEMPID?.trim(),
          lead_coordinator:
            dataForAPI.coordinator == "GENERAL" ? "" : dataForAPI.coordinator,// if selected coordinator is general pass blank string
          lead_salesperson: dataForAPI.salesperson?.trim(),
          lead_teamid: "0",
          lead_CampaignId: dataForAPI.campaignId,
          lead_account: dataForAPI.account,
          lead_organization: dataForAPI.organization,
          lead_notes: dataForAPI.notes,
          lead_country: dataForAPI.country,
          lead_city: dataForAPI.city,
          lead_territory: dataForAPI.territory,
          lead_area: dataForAPI.area,
          lead_streetaddress: dataForAPI.streetAddress,
          lead_location: dataForAPI.location,
          lead_appartment: dataForAPI.apartment,
          lead_primarycontact: dataForAPI.name,
          lead_primarycontacttitle: dataForAPI.title,
          lead_phone: dataForAPI.phone,
          lead_isphonewhatsapp: dataForAPI.isPhoneWhatsApp,
          lead_alt_phone: dataForAPI.alternatePhone,
          lead_alt_isphonewhatsapp: dataForAPI.isAlternatePhoneWhatsApp,
          lead_email: dataForAPI.email,
          lead_stage: "",
          lead_probability: dataForAPI.probability,
          // lead_probability: Number(dataForAPI.probability),
          lead_priority: dataForAPI.priority,
          // lead_priority: getPriorityName(dataForAPI.priority),
          lead_source: dataForAPI.leadSource,
          lead_status: dataForAPI.status,
          lead_assignedto: dataForAPI.assignTo,
          lead_bookedamount: Number(dataForAPI.bookedAmount),
          lead_currencycode: currencyList[0].curno, // dataForAPI.currency,
          lead_currencyrate: "1",
          deptno: currentDepartmentFromLocalStorage,
          prod_code: "",
          prod_Description: "",
          prod_Unit: "",
          prod_Qty: "0",
          prod_Price: "0",
          prod_Amount: 0,
          prod_Comments: "",
          prod_imagepath: "",
          autoid: dataForAPI.autoid ? dataForAPI.autoid : "0",
        },
      ];
    }
    const jsonToSend = JSON.stringify(arrayWeHaveToGiveToAPI);
    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRM_LeadRegisterNew`;

    console.log("json to send to LEAD REGISTER", jsonToSend);

    axios
      .post(apiUrl, jsonToSend, {
        headers: {
          // Overwrite Axios's automatically set Content-Type
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log("res is ", dataForAPI);
        setOpenSubmitSnackbar(true); // Show success snackbar

        setOpenDialogBox(true);

        if (res.data.result === "Saved") {
          setMessageForUser({
            result: "success",
            title: "Success",
            message: "Successfully Saved",
          });
          console.log("success");

          clearProductsList();
          clearLeadList();

          setAddProduct(false);
          setProductEntries([]);
        } else {
          setMessageForUser({
            result: "failure",
            title: "Error",
            message: "Could not save, something went wrong",
          });
          console.log("failure");
        }
      })
      .catch((err) => {
        console.log("error while posting lead", err);
      });
  };

  const productEntryInAllEntries = (productEntryTimeline) => {
    console.log("productEntryTimeline from all entries:", productEntryTimeline);

    // Ensure productEntryTimeline has data and extract the first entry
    const productFormData =
      productEntryTimeline && productEntryTimeline[0]
        ? productEntryTimeline[0]
        : {};

    console.log("productFormData:", productFormData);

    const isProductAdded = !!(
      productFormData.itemCode ||
      productFormData.itemDescription ||
      productFormData.itemUnit ||
      productFormData.itemCurrentStock ||
      productFormData.itemQuantity ||
      productFormData.itemPrice ||
      productFormData.itemAmount
    );

    console.log("isProductAdded ::  :", isProductAdded);

    setFormData((prevFormData) => ({
      ...prevFormData,
      isItemAdded: isProductAdded,
      itemCode: productFormData.itemCode || "",
      itemDescription: productFormData.itemDescription || "",
      itemUnit: productFormData.itemUnit || "",
      itemCurrentStock: productFormData.itemCurrentStock || "",
      itemQuantity: productFormData.itemQuantity || "",
      itemPrice: productFormData.itemPrice || "",
      itemAmount: productFormData.itemAmount || "",
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: checked,
    }));
  };

  const handlePriorityClick = (level) => {
    console.log("level handlePriorityClick:", level);
    setFormData({ ...formData, priority: level });
  };

  useEffect(() => {
    const savedProducts = localStorage.getItem("currentEdittingProductsList");
    if (savedProducts && JSON.parse(savedProducts).length > 0) {
      setAddProduct(true);
      // setProductEntries(JSON.parse(savedProducts)); // Restore previous state
    }

    getCurrencylist();
  }, []);

  const onAddProduct = () => {
    setAddProduct(true);
  };

  const [territoryLabel, setTerritoryLabel] = useState("Territory");

  const nameRegex = /^[A-Za-z\s]{2,50}$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // const [showOrganizationListDropdown, setShowOrganizationListDropdown] = useState(false);
  const [showNameListDropdown, setShowNameListDropdown] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const dropdownListRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
      // setShowNameListDropdown(false);
    }
  };

  const handleListClickOutside = (event) => {
    if (
      dropdownListRef.current &&
      !dropdownListRef.current.contains(event.target)
    ) {
      // setShowDropdown(false);
      setShowNameListDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleListClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleListClickOutside);
    };
  }, []);

  const callCordinatorListAPI = () => {
    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/MasterCount/${company_code_from_local_storage}/COORDINATORLIST/-/${currentDepartmentFromLocalStorage}`;
    axios
      .get(apiUrl)
      .then((res) => {
        setCoordinatorList([
          { EMP_ID: "GENERAL", NAME: "GENERAL" },
          ...res.data,
        ]);
      })
      .catch((err) => {});
  };

  const callSalesPersonListAPI = () => {
    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/MasterCount/${company_code_from_local_storage}/SALESPERSONLIST/-/${currentDepartmentFromLocalStorage}`;
    axios
      .get(apiUrl)
      .then((res) => {
        setSalesPersonList(res.data);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    callCordinatorListAPI();
    callSalesPersonListAPI();
  }, []);

  const handleKeyDown = (e, currentField) => {
    if (e.key === "Enter") {
      e.preventDefault();

      const fieldOrder = [
        "organization",
        "email",
        "phone",
        "alternatePhone",
        "lead",
        "status",
        "title",
        "notes",
        "leadSource",
        "coordinator",
        "salesperson",
        "campaignId",
        "departmentNo",
        "probability",
        "currency",
        "bookedAmount",
        "country",
        "territory",
        "streetAddress",
        "city",
        "apartment",
        "area",
        "location",
      ];

      const currentIndex = fieldOrder.indexOf(currentField);

      if (currentIndex !== -1 && currentIndex < fieldOrder.length - 1) {
        const nextField = fieldOrder[currentIndex + 1];
        const nextElement = document.querySelector(
          `input[name="${nextField}"], div[id="${nextField}"]`
        );
        if (nextElement) {
          nextElement.focus();
          if (nextElement.tagName === "DIV") {
            nextElement.click();
          }
        }
      }
    }
  };

  const handleCustomerSelect = async (customer) => {
    let customerList = await fetchOrganizationListForF2Search(
      customer?.ACCOUNT
    );

    console.log(
      "customer on modal select customerList",
      customer,
      customerList
    );

    selectCustomerOrganization(customerList[0]);

    setF2CustomerSearch((prev) => !prev);
  };

  useEffect(() => {
    if (addProduct && productEntries.length === 0) {
      handleAddRow(null);
    }
  }, [addProduct, productEntries.length]);

  const getCurrencylist = () => {
    console.log("calling get currency list")
    let API_PATHS = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";
    const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";
    let url = `${BASE_URL}/api/cpayscount/${company_code_from_local_storage}/currency/-/-`

    console.log("calling get currency list url", url)

    axios
      .get(url)
      .then((res) => {
        setCurrencyList(res.data);
        if (res.data) {
          setCurrency(res.data[0].curno);
        }
      })
      .catch((err) => {
        console.log("err ", err);
      });
  };

  // Fetch total count for modal stock listing
  const fetchModalTotalCount = useCallback(
    async (query = "-", searchByValue = searchBy) => {
      let API_PATHS = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";
      const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";

      try {
        const effectiveQuery =
          query?.trim() === "" ? "-" : query?.trim() || "-";
        const formattedQuery = effectiveQuery.replace(/\//g, "%2F");
        const url = `${BASE_URL}/api/cpayscount/${company_code_from_local_storage}/ITEMCOUNT/${searchByValue}/${formattedQuery}`;
        const response = await request({
          url: url,
          method: "GET",
          timeout: 5000,
        });
        if (Array.isArray(response) && response[0]?.CNT) {
          setModalTotalRows(Number(response[0].CNT));
        } else {
          setModalTotalRows(0);
        }
      } catch (err) {
        console.error("Failed to fetch total count", err);
        setModalTotalRows(0);
      }
    },
    [company_code_from_local_storage, searchBy]
  );

  const fetchProductData = useCallback(
    async (
      query = "-",
      searchByValue = searchBy,
      location = "A",
      pageNum = modalPageNumber,
      limit = modalPageSize
    ) => {
      let API_PATHS = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";
      const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";

      const effectiveQuery = query?.trim() === "" ? "-" : query?.trim() || "-";
      const formattedQuery = effectiveQuery.replace(/\//g, "%2F");
      try {
        const url = `${BASE_URL}/api/CRMStockListPage/${company_code_from_local_storage}/${searchByValue}/${formattedQuery}/${location}/-/${pageNum}/${limit}`;
        const response = await request({
          url: url,
          method: "GET",
          timeout: 5000,
        });
        if (response) {
          setModalSuggestions(response);
          return response;
        } else {
          setModalSuggestions([]);
          return [];
        }
      } catch (err) {
        console.error("Failed to fetch product data", err);
        setModalSuggestions([]);
        return [];
      }
    },
    [
      company_code_from_local_storage,
      searchBy,
      modalPageNumber,
      modalPageSize,
    ]
  );

  const handleModalSearchQueryChange = useCallback(
    async (query = "-") => {
      setModalSearchQuery(query);
      setModalPageNumber(1);
      fetchProductData(query, searchBy, "A", 1, modalPageSize);
      fetchModalTotalCount(query, searchBy);
    },
    [fetchProductData, fetchModalTotalCount, searchBy, modalPageSize]
  );

  useEffect(() => {
    if (f2PopupViewToggle) {
      fetchProductData(
        modalSearchQuery,
        searchBy,
        "A",
        modalPageNumber,
        modalPageSize
      );
    }
  }, [
    modalPageNumber,
    modalPageSize,
    f2PopupViewToggle,
    searchBy,
    fetchProductData,
    modalSearchQuery,
  ]);

  const selectedProject = (item)=>{
    
      console.log("Selected:", item);

      setF2PopupProjectViewToggle(false); // ← set false directly, not toggle

      setFormData({
        ...formData,
        campaignId: item.Description,
      });
      
  }

  return (
    <div className="flex  justify-center items-center  mobile-only-lead-entry-form">
      <form
        onSubmit={(e) => e.preventDefault()}
        className="bg-white rounded-lg px-4 pt-2 w-full  shadow"
      >
        <div className="flex   justify-between items-center">
          <div></div>
          <button
            type="button"
            onClick={(e) => cancelForm(e)}
            className="text-gray-700 bg-gray-200 hover:bg-gray-300 px-4 py-2 my-2 rounded w-40 transition"
          >
            Clear All Data
          </button>
        </div>
        <div className="allEntriesDivHeading flex justify-between items-center ">
          <h2 className="text-2xl font-normal text-center my-2 text-gray-600">
            {formData.isEditinglead ? "Edit Lead" : "Lead Entry Form"}
          </h2>

          {<span> Customer Account : {formData.account}</span>}
          {<span> AutoID : {formData.autoid}</span>}
        </div>

        {console.log("productEntries in allEntriesForm", productEntries)}

        {productEntries != undefined &&
        productEntries?.some(
          (prod) => !prod.isSelectedItemCodeCorrect && prod.itemCode.length > 0
        ) ? (
          <Snackbar
            open={openSnackbar}
            autoHideDuration={3000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <MuiAlert
              onClose={handleCloseSnackbar}
              severity="error"
              sx={{ width: "100%" }}
            >
              {`Item Code is not Correct at row ${errorRow} `}
            </MuiAlert>
          </Snackbar>
        ) : (
          <Snackbar
            open={openSubmitSnackbar}
            autoHideDuration={3000}
            onClose={handleCloseSubmitSnackbar}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <MuiAlert
              onClose={handleCloseSnackbar}
              severity="success"
              sx={{ width: "100%" }}
            >
              Form Submitted Successfully!
            </MuiAlert>
          </Snackbar>
        )}

        {duplicateItemCodeSnackbar && (
          <Snackbar
            open={duplicateItemCodeSnackbar}
            autoHideDuration={3000}
            onClose={handleCloseSubmitSnackbar}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <MuiAlert
              onClose={handleCloseSnackbar}
              severity="error"
              sx={{ width: "100%" }}
            >
              This item is already selected. Duplicate entries are not allowed!
            </MuiAlert>
          </Snackbar>
        )}

        <div className="leadFormDivAllEntries grid grid-cols-4 gap-4">
          {/* <div className="mb-0 relative" ref={dropdownRef}>
            <TextField
              label="Customer / Organization"
              name="organization"
              required
              value={formData.organization}
              onChange={(e) => {
                handleChange(e);
                setShowDropdown(true);
              }}
              onKeyDown={(e) => handleKeyDown(e, "organization")}
              placeholder="Enter Customer Organization"
              fullWidth
              variant="standard"
              id="standard"
              autoComplete="off"
              color="red-500"
              error={!formData.organization}
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important",
                },
              }}
            />

            {organizationList &&
              showDropdown &&
              formData.organization?.length > 0 && (
                <div className="absolute top-15 left-0 w-64 bg-gray-100 max-h-[300px] overflow-y-auto scrollbar-thin shadow-lg z-50 border border-gray-300">
                  {console.log("organizationList:", organizationList)}
                  {organizationList.map((organization, index) => (
                    <div
                      onClick={() => {
                        selectCustomerOrganization(organization);
                        setShowDropdown(false);
                      }}
                      key={index}
                      className="px-1 py-0.5 border bg-white hover:bg-gray-200"
                    >
                      <p className="font-normal">{organization.Custname}</p>
                    </div>
                  ))}
                </div>
              )}
          </div> */}

          {/* new code  */}
          <Autocomplete
            // 1. Data Source
            options={organizationList} // Use the fetched list as options
            // 2. Value Management

            getOptionKey={(option) => {
              if (typeof option === "string") {
                return option;
              }
              // Use a unique ID if available (best option)
              return option.account;
            }}
            value={formData.organization}
            onChange={(event, newValue) => {
              // When an option is selected (or text is typed/cleared)
              if (typeof newValue === "string" || newValue === null) {
                // This branch handles text input or clearing the field
                handleChange({
                  target: { name: "organization", value: newValue || "" },
                });
              } else if (newValue && newValue.Custname) {
                // This branch handles selection from the list (newValue is the selected object)
                selectCustomerOrganization(newValue);
                handleKeyDown(event, "organization");
              }
            }}
            // 3. Input Handling
            onInputChange={(event, newInputValue, reason) => {
              // This is crucial for managing the text input field
              if (reason === "input") {
                handleChange({
                  target: { name: "organization", value: newInputValue },
                });
              }
            }}
            getOptionLabel={(option) => {
              // How to display the option (handle both string and object)
              if (typeof option === "string") {
                return option;
              }
              return (
                (
                  <div>
                    <p>{option.Custname}</p>
                    <p>
                      <span>phone:</span>
                      {option.phone}
                    </p>
                    <div className="flex justify-between w-full">
                      <p>
                        {" "}
                        <span>account:</span>
                        {option.account}
                      </p>
                      <p>
                        <span>autoid:</span>
                        <span className="font-bold rounded bg-blue-500 text-white p-1">
                          {" "}
                          {option.autoid}
                        </span>
                      </p>
                    </div>
                  </div>
                ) || ""
              );
            }}
            // 4. Rendering the Input Field (The visual text box)
            renderInput={(params) => (
              <TextField
                {...params}
                label="Customer / Organization"
                name="organization"
                inputRef={organizationInputRef}
                required
                fullWidth
                variant="standard"
                onKeyDown={(e) => handleKeyDown(e, "organization")}
                error={!formData.organization}
                autoFocus={true}
                sx={{
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                  "& .MuiInputBase-input:focus": {
                    boxShadow: "none !important",
                  },
                }}
              />
            )}
            // 5. Filtering (Optional, but good practice)
            filterOptions={(options, state) => options} // Prevent default filtering since you fetch data based on input
            // 6. Access the option's value
            getOptionValue={(option) => option.Custname}
          />
          {/* new code ends */}

          <div className="mb-0 ">
            <TextField
              label="Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              onKeyDown={(e) => handleKeyDown(e, "email")}
              placeholder="Enter lead Email"
              fullWidth
              // required={isEmailRequired}
              variant="standard"
              error={canUserSeeThis("ZJ") && (!formData.email || !emailRegex.test(formData.email))}
              helperText={
                canUserSeeThis("ZJ") && formData.email && !emailRegex.test(formData.email)
                  ? "Enter a valid email address (e.g., example@domain.com)"
                  : ""
              }
              // error={
              //   isEmailRequired &&
              //   (!formData.email || !emailRegex.test(formData.email))
              // }
              // helperText={
              //   isEmailRequired &&
              //   formData.email &&
              //   !emailRegex.test(formData.email)
              //     ? "Enter a valid email address (e.g., example@domain.com)"
              //     : ""
              // }
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important",
                },
              }}
            />
          </div>

          <div className="flex justify-between items-center ">
            <div className="mb-0 w-[85%]">
              <TextField
                label="Phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                onKeyDown={(e) => handleKeyDown(e, "phone")}
                placeholder="Enter lead Phone Number"
                fullWidth
                required
                variant="standard"
                id="standard"
                error={!formData.phone}
                sx={{
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                  "& .MuiInputBase-input:focus": {
                    boxShadow: "none !important",
                  },
                  width: "100%",
                }}
              />
            </div>
            <div>
              <div className="flex justify-center items-center gap-2">
                <img
                  src={whatsapp}
                  alt="whatsapp-icon"
                  className="w-5 h-5 object-contain"
                />
                <input
                  type="checkbox"
                  className="rounded border border-sm shadow cursor-pointer"
                  name="isPhoneWhatsApp"
                  checked={formData.isPhoneWhatsApp}
                  onChange={handleCheckboxChange}
                />
              </div>
            </div>
          </div>

          <div className="flex justify-between items-center">
            <div className="mb-0 w-[85%]">
              <TextField
                label="Alternate Phone"
                name="alternatePhone"
                type="number"
                value={formData.alternatePhone}
                onChange={handleChange}
                onKeyDown={(e) => handleKeyDown(e, "alternatePhone")}
                placeholder="Enter Alt Phone Number"
                fullWidth
                variant="standard"
                id="standard"
                sx={{
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                  "& .MuiInputBase-input:focus": {
                    boxShadow: "none !important",
                  },
                  width: "100%",
                }}
              />
            </div>

            <div className="flex justify-center items-center gap-2">
              <img
                src={whatsapp}
                alt="whatsapp-icon"
                className="w-5 h-5 object-contain"
              />
              <input
                type="checkbox"
                className="rounded border border-sm shadow cursor-pointer"
                name="isAlternatePhoneWhatsApp"
                checked={formData.isAlternatePhoneWhatsApp}
                onChange={handleCheckboxChange}
              />
            </div>
          </div>

          <div className="mb-0 relative" ref={dropdownListRef}>
            <TextField
              label="Contact Person"
              name="lead"
              value={formData.lead}
              onChange={(e) => {
                handleChange(e);
                setShowNameListDropdown(true);
              }}
              onKeyDown={(e) => handleKeyDown(e, "lead")}
              placeholder="Enter Contact Name"
              fullWidth
              required
              variant="standard"
              id="standard"
              error={!formData.lead}
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important",
                },
              }}
            />
          </div>

          <div className="mb-0">
            <TextField
              select
              label="Status"
              name="status"
              value={formData.status}
              onChange={handleChange}
              onKeyDown={(e) => handleKeyDown(e, "status")}
              fullWidth
              required
              variant="standard"
              id="status"
              error={!formData.status}
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important",
                },
              }}
            >
              <MenuItem value="newLead">
                <button className="w-full bg-orange-400 text-white px-4 py-0 rounded">
                  New Lead
                </button>
              </MenuItem>

              <MenuItem value="contacted">
                <button className="w-full bg-blue-600 text-white px-4 py-0 rounded">
                  Contacted
                </button>
              </MenuItem>

              <MenuItem value="attemptedToContact">
                <button className="w-full bg-red-400 text-white px-4 py-0 rounded">
                  Attempted to Contact
                </button>
              </MenuItem>

              <MenuItem value="qualified">
                <button className="w-full bg-green-400 text-white px-4 py-0 rounded">
                  Qualified
                </button>
              </MenuItem>

              <MenuItem value="unQualified">
                <button className="w-full bg-red-600 text-white px-4 py-0 rounded">
                  Unqualified
                </button>
              </MenuItem>
            </TextField>
          </div>

          <div className="mb-0">
            <TextField
              label="Title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              onKeyDown={(e) => handleKeyDown(e, "title")}
              placeholder="Enter lead Title"
              fullWidth
              variant="standard"
              id="standard"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important",
                },
              }}
            />
          </div>

          <div className="mb-0">
            <TextField
              label="Lead Notes"
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              onKeyDown={(e) => handleKeyDown(e, "notes")}
              placeholder="Enter lead Notes"
              fullWidth
              variant="standard"
              id="standard"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important",
                },
              }}
            />
          </div>

          <div className="mb-0">
            <TextField
              select
              label="Lead Source"
              name="leadSource"
              value={formData.leadSource}
              onChange={handleChange}
              onKeyDown={(e) => handleKeyDown(e, "leadSource")}
              fullWidth
              variant="standard"
              id="leadSource"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important",
                },
              }}
            >
              <MenuItem value="" disabled>
                Select Status
              </MenuItem>

              <MenuItem value="Email-AI">Email-AI</MenuItem>
              <MenuItem value="walkin">Walk-in</MenuItem>
              <MenuItem value="phone">Phone</MenuItem>
              <MenuItem value="whatsapp">Whatsapp</MenuItem>
              <MenuItem value="email">E-mail</MenuItem>
              <MenuItem value="online">Online</MenuItem>
              <MenuItem value="otherSource">Others</MenuItem>
            </TextField>
          </div>

          {/* <div className="mb-0">
            <p>Coordinator</p>
            <h4>
              {accessgroupFromLocal === "COORDINATOR" ||
              accessgroupFromLocal === "ADMIN"
                ? userName
                : "GENERAL"}
            </h4>
          </div> */}

          <div className="mb-0">
            <TextField
              select
              label="Coordinator"
              name="coordinator"
              value={formData.coordinator}
              onChange={handleChange}
              onKeyDown={(e) => handleKeyDown(e, "coordinator")}
              fullWidth
              variant="standard"
              id="coordinator"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important",
                },
              }}
            >
              <MenuItem value="" disabled>
                Select Coordinator
              </MenuItem>

              {coordinatorList?.map((item) => {
                return (
                  <MenuItem value={item.EMP_ID?.trim()}>{item.NAME}</MenuItem>
                );
              })}
            </TextField>
          </div>

          <div className="mb-0">
            <TextField
              select
              label="Sales Person"
              name="salesperson"
              value={formData.salesperson}
              onChange={handleChange}
              onKeyDown={(e) => handleKeyDown(e, "salesperson")}
              fullWidth
              required
              // disabled={!isAdmin}
              variant="standard"
              id="salesperson"
              error={!formData.salesperson}
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important",
                },
              }}
            >
              <MenuItem value="" disabled>
                Select Sales Person
              </MenuItem>

              {salespersonList?.map((item) => {
                return (
                  <MenuItem value={item.EMP_ID?.trim()}>{item.NAME}</MenuItem>
                );
              })}
            </TextField>
          </div>

          <div className="mb-0">
            <TextField
              label="Project/Campaign"
              name="campaignId"
              value={formData.campaignId}
              onChange={handleChange}
              onKeyDown={(e) => handleKeyDown(e, "campaignId")}
              placeholder="Project or Campaign"
              fullWidth
              required
              variant="standard"
              id="standard"
               error={canUserSeeThis("ZH") && !formData.campaignId } // project field mandatory if accesskey has ZH
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important",
                },
              }}
            />
          </div>

          <div className="mb-0">
            <TextField
              select
              key={formData.departmentNo}
              label="Department No"
              name="departmentNo"
              value={formData.departmentNo}
              onChange={handleChange}
              onKeyDown={(e) => handleKeyDown(e, "departmentNo")}
              fullWidth
              variant="standard"
              id="departmentNo"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important",
                },
              }}
            >
              <MenuItem value="" disabled>
                Select Department
              </MenuItem>
              <MenuItem value="dept101">Sales</MenuItem>
              <MenuItem value="dept102">Marketing</MenuItem>
              <MenuItem value="dept103">Customer Support</MenuItem>
              <MenuItem value="dept104">IT</MenuItem>
              <MenuItem value="dept105">Finance</MenuItem>
              <MenuItem value="dept106">HR</MenuItem>
              <MenuItem value="dept107">Logistics</MenuItem>
              <MenuItem value="dept108">R&D</MenuItem>
            </TextField>
          </div>

          <div className="mb-0">
            <FormControl fullWidth variant="standard">
              <InputLabel id="leadProbability-label">
                Lead Probability (%)
              </InputLabel>
              <Select
                labelId="leadProbability-label"
                id="probability"
                name="probability"
                value={formData.probability || ""}
                onChange={handleChange}
                onKeyDown={(e) => handleKeyDown(e, "probability")}
              >
                {[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map((value) => (
                  <MenuItem key={value} value={value}>
                    {value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <div className="mb-4 flex items-center space-x-4">
            <TextField
              inputRef={currencyRef}
              select
              slotProps={{
                input: { readOnly: true },
              }}
              label="Currency"
              name="currency"
              value={currency}
              onChange={handleChange}
              onKeyDown={(e) => handleKeyDown(e, "currency")}
              variant="standard"
              id="currency"
              sx={{
                width: "100px",
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                  fontSize: "13px",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important",
                },
              }}
            >
              {currencyList?.map((item) => {
                return <MenuItem value={item.curno}>{item.curno}</MenuItem>;
              })}
            </TextField>

            <TextField
              label="Booked Amount"
              name="bookedAmount"
              type="number"
              value={formData.bookedAmount || ""}
              onChange={handleChange}
              onKeyDown={(e) => handleKeyDown(e, "bookedAmount")}
              fullWidth
              variant="standard"
              InputProps={{
                inputProps: { min: 0 },
              }}
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important",
                },
              }}
            />
          </div>

          <div className="mb-0">
            <TextField
              select
              label="Country"
              name="country"
              value={formData.country || ""}
              onChange={handleChange}
              onKeyDown={(e) => handleKeyDown(e, "country")}
              fullWidth
              variant="standard"
              id="country"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important",
                },
              }}
            >
              {countries.map((country) => (
                <MenuItem key={country.value} value={country.value}>
                  {country.label}
                </MenuItem>
              ))}
            </TextField>
          </div>

          <div className="mb-0">
            {"United Arab Emirates" === formData.country ? (
              <TextField
                select
                label={territoryLabel}
                name="territory"
                value={formData.territory}
                onChange={handleChange}
                onKeyDown={(e) => handleKeyDown(e, "territory")}
                fullWidth
                variant="standard"
                id="territory"
                sx={{
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                  "& .MuiInputBase-input:focus": {
                    boxShadow: "none !important",
                  },
                }}
              >
                <MenuItem value="" disabled>
                  Select {territoryLabel}
                </MenuItem>
                <MenuItem value="dubai">Dubai</MenuItem>
                <MenuItem value="abudhabi">Abu Dhabi</MenuItem>
                <MenuItem value="sharjah">Sharjah</MenuItem>
                <MenuItem value="ajman">Ajman</MenuItem>
                <MenuItem value="otherTerritory">Others</MenuItem>
              </TextField>
            ) : (
              <TextField
                label={territoryLabel}
                name="territory"
                value={formData.territory}
                onChange={handleChange}
                onKeyDown={(e) => handleKeyDown(e, "territory")}
                fullWidth
                variant="standard"
                id="territory"
                placeholder={`Enter ${territoryLabel}`}
                sx={{
                  "& .MuiInputLabel-root": {
                    fontFamily: "Figtree, sans-serif",
                  },
                  "& .MuiInputBase-input:focus": {
                    boxShadow: "none !important",
                  },
                }}
              />
            )}
          </div>

          <div className="mb-0">
            <TextField
              label="Street Address"
              name="streetAddress"
              value={formData.streetAddress || ""}
              onChange={handleChange}
              onKeyDown={(e) => handleKeyDown(e, "streetAddress")}
              fullWidth
              variant="standard"
              id="standard"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important",
                },
              }}
            />
          </div>

          <div className="mb-0">
            <TextField
              label="City"
              name="city"
              value={formData.city || ""}
              onChange={handleChange}
              onKeyDown={(e) => handleKeyDown(e, "city")}
              fullWidth
              variant="standard"
              id="standard"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important",
                },
              }}
            />
          </div>

          <div className="mb-0">
            <TextField
              label="Apartment (Optional)"
              name="apartment"
              value={formData.apartment || ""}
              onChange={handleChange}
              onKeyDown={(e) => handleKeyDown(e, "apartment")}
              fullWidth
              variant="standard"
              id="standard"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important",
                },
              }}
            />
          </div>

          <div className="mb-0">
            <TextField
              label="Area Name"
              name="area"
              type="text"
              value={formData.area}
              onChange={handleChange}
              onKeyDown={(e) => handleKeyDown(e, "area")}
              placeholder="Enter lead Area name"
              fullWidth
              variant="standard"
              id="standard"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important",
                },
              }}
            />
          </div>

          <div className="mb-0">
            <TextField
              label="Location"
              name="location"
              type="text"
              value={formData.location}
              onChange={handleChange}
              onKeyDown={(e) => handleKeyDown(e, "location")}
              placeholder="Enter lead Location"
              fullWidth
              variant="standard"
              id="standard"
              sx={{
                "& .MuiInputLabel-root": {
                  fontFamily: "Figtree, sans-serif",
                },
                "& .MuiInputBase-input:focus": {
                  boxShadow: "none !important",
                },
              }}
            />
          </div>

          <div className=" flex gap-4 items-center justify-left mt-4 ">
            <label className="block font-normal text-base text-black text-opacity-60">
              Priority
            </label>
            <div className="flex space-x-2">
              {[1, 2, 3].map((level, index) => (
                <button
                  key={`${level}-${index}`}
                  type="button"
                  className={`text-2xl transition-all duration-300 ease-in-out ${
                    formData.priority >= level
                      ? "text-yellow-500 transform scale-110"
                      : "text-gray-400 transform scale-100"
                  } hover:scale-125 hover:text-yellow-500`}
                  onClick={() => handlePriorityClick(level)}
                >
                  ★
                </button>
              ))}
            </div>
          </div>

          {!addProduct && (
            <div className=" flex gap-4 items-center justify-end mt-4 ">
              <div>
                <button
                  type="button"
                  className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-700"
                  onClick={onAddProduct}
                >
                  Add Product
                </button>
              </div>
            </div>
          )}
        </div>
        {addProduct && (
          <ProductsInfo
            lead={formData.lead}
            productEntryInAllEntries={productEntryInAllEntries}
            onAddProducts={addProduct}
            clearProductsList={clearProductsList}
            productEntries={productEntries}
            setProductEntries={setProductEntries}
            handleAddRow={handleAddRow}
            handleDeleteSelected={handleDeleteSelected}
            handleInputChange={handleInputChange}
            selectProduct={selectProduct}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            currentProductEntryRowId={currentProductEntryRowId}
            productData={productData}
            setCurrentF2ItemForSearchPopup={setCurrentF2ItemForSearchPopup}
            rowInputRefs={rowInputRefs}
            qtyInputRefsFromParent={qtyInputRefsFromParent} 
          />
        )}

        <div className="flex justify-center pt-3 pb-0  gap-4 ">
          {showDupCheckName ? (
            "Checking please wait"
          ) : (
            <button
              type="button"
              className={`text-white px-4 py-2 my-2 rounded w-40 ${
                formData.organization &&
                formData.lead &&
                formData.phone &&
                formData.salesperson &&
                formData.status && 
                
                (!canUserSeeThis("ZJ") || (formData.email && emailRegex.test(formData.email))) &&
                (!canUserSeeThis("ZH") || formData.campaignId) 
                  ? "bg-blue-500 hover:bg-blue-700"
                  : "bg-gray-400 hover:bg-gray-500 cursor-not-allowed"
              }`}
              onClick={(e) => handleSubmit(e)}
              disabled={
                !formData.organization ||
                !formData.lead ||
                !formData.status ||
                !formData.salesperson ||
                !formData.phone || 
                (canUserSeeThis("ZJ") && (!formData.email || !emailRegex.test(formData.email))) ||
                (canUserSeeThis("ZH") && !formData.campaignId)
              }
            >
              Submit
            </button>
          )}
        </div>
      </form>

      {/* {f2PopupViewToggle && currentF2ItemForSearchPopup && (
        <ItemSearchPopup
          lead={formData.lead}
          productEntryInAllEntries={productEntryInAllEntries} // no need
          onAddProducts={addProduct} //no need
          clearProductsList={clearProductsList} // no need
          productEntries={productEntries}
          setProductEntries={setProductEntries}
          handleAddRow={handleAddRow} // no need
          handleDeleteSelected={handleDeleteSelected} // no need
          handleInputChange={handleInputChange} // no need
          selectProduct={selectProduct}
          selectedRows={selectedRows} // no need
          setSelectedRows={setSelectedRows} // no need
          currentProductEntryRowId={currentProductEntryRowId} // no need
          productData={productData} // no need
          setF2PopupViewToggle={setF2PopupViewToggle}
          currentF2ItemForSearchPopup={currentF2ItemForSearchPopup}
          setDuplicateItemCodeSnackbar={setDuplicateItemCodeSnackbar}
        />
      )} */}
      {/* ttl_stk is current stock */}
      <Modal
        isOpen={f2PopupViewToggle}
        onClose={() => setF2PopupViewToggle(false)}
        title={"Products List"}
        size="xxl"
        header={true}
      >
        <div className="product-modal-container">
          <ProductsModal
            modalSuggestions={modalSuggestions}
            handleProductSelect={(product) => {
              console.log("product", product);

              const rowId = currentF2ItemForSearchPopup.id;

              setProductEntries((prevEntries) =>
                prevEntries.map((entry) =>
                  entry.id === currentF2ItemForSearchPopup.id
                    ? {
                        ...entry,
                        itemCode: product.Code,
                        itemDescription: product.Description,
                        itemImage: product.Imagepath,
                        // itemUnit: product.unit,
                        itemUnit: product.Unit,
                        itemCurrentStock: product.Ttl_Stk, // Adjust according to your product data
                        itemPrice: product.SelPrice, // Adjust according to your product data
                        itemAmount: product.SelPrice * entry.itemQuantity, // Example calculation
                        isSelectedItemCodeCorrect: true, // Example calculation
                      }
                    : entry
                )
              );
              setF2PopupViewToggle(false);
              setTimeout(() => {
                if (qtyInputRefsFromParent.current[rowId]) {
                  qtyInputRefsFromParent.current[rowId].focus();
                  qtyInputRefsFromParent.current[rowId].select();
                }
              }, 0);
            }}
            onSearchQueryChange={handleModalSearchQueryChange}
            loading={loading}
            setSearchBy={setSearchBy}
            searchBy={searchBy}
            pageNumber={modalPageNumber}
            pageSize={modalPageSize}
            totalRows={modalTotalRows}
            onPageChange={setModalPageNumber}
            searchQuery={modalSearchQuery}
            onRefresh={() =>
              fetchProductData(
                modalSearchQuery,
                searchBy,
                "A",
                modalPageNumber,
                modalPageSize
              )
            }
          />
        </div>
      </Modal>

      {/* <CustomerSearchF2Popup userDepartment={userDepartment} selectCustomerOrganization={selectCustomerOrganization} setF2CustomerSearch={setF2CustomerSearch} /> */}

      {/*Common Modal */}
      <Modal
        isOpen={f2CustomerSearch}
        onClose={() => setF2CustomerSearch((prev) => !prev)}
        title="Select Customer"
        size="xxl"
        header={true}
      >
        <CreditCustomerList
          handleCustomerSelect={handleCustomerSelect}
          defaultType="Customers"
        />
      </Modal>

      {/*Project Modal */}
      <Modal
        isOpen={f2PopupProjectViewToggle}
        onClose={() => setF2PopupProjectViewToggle(false)} // ← false directly
        title="Select Project/Campaign"
        size="xxl"
        header={true}
      >

        <JobCodeList 
         onClose={() => setF2PopupProjectViewToggle(false)} // ← false directly
        onSelect={(job)=>selectedProject(job)} 
        BASE_URL={`${apiPaths_from_local_storage[0].API_CONFIG}`} 
        COMPANY_CODE={company_code_from_local_storage}/>

      </Modal>
    </div>
  );
};

export default AllEntriesForm;
